import styled from '@emotion/styled';

export const CAROUSEL_CARD_HEIGHT = 216;
export const CAROUSEL_CHART_HEIGHT = 104;

export const CarouselCardContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[16],
  height: CAROUSEL_CARD_HEIGHT,
  padding: theme.spacing[16],
  borderRadius: theme.radius[16],
  backgroundColor: theme.colors.background.canvas,
  border: `1px solid ${theme.colors.border.default}`,
}));

export const CarouselCardHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[8],
}));

export const CarouselCardValueRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[8],
}));

export const CarouselCardDeltaChip = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing[4],
  padding: `${theme.spacing[2]}px ${theme.spacing[8]}px`,
  borderRadius: theme.radius[8],
  backgroundColor: theme.colors.brand.subtle,
  color: theme.colors.brand.text,
  whiteSpace: 'nowrap',
}));

export const CarouselCardChartArea = styled('div')({
  height: CAROUSEL_CHART_HEIGHT,
  minHeight: CAROUSEL_CHART_HEIGHT,
});
